import {useLocation} from 'react-router-dom';
import {DefaultRootState, useSelector} from 'react-redux';

export const useIsLandingPage = (): boolean => {
    const {pathname} = useLocation();
    return pathname === '/';
};

export const useIsSearchPage = (): boolean => {
    const isLandingPageEnabled = useSelector((state: DefaultRootState) => state.config.uiConfig.landingPage.enabled);
    const {pathname} = useLocation();
    return pathname.toString().startsWith('/search') || (!isLandingPageEnabled && pathname === '/');
};

export const useIsAnalysisPage = (): boolean => {
    const {pathname} = useLocation();
    return pathname === '/analysis' || pathname === '/analysis/';
};

export const useIsAssistantPage = (): boolean => {
    const {pathname} = useLocation();
    return pathname === '/assistant' || pathname === '/assistant/';
};

export const useIsDocumentAssistantPage = (): boolean => {
    const {pathname} = useLocation();
    return pathname === '/document-assistant' || pathname === '/document-assistant/';
};
